import * as Mui from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import useOperationTranslation from "../../../../hooks/useOperationTranslation";
import { customTheme } from "../../../../../../config/theme/MuiTheme";

interface Props {
    open: boolean;
    onReopen: () => void;
    taskName : string;
    onReopenTask: () => void;
};
const ReopenTaskConfirmation = (props: Props) => {
    const t = useOperationTranslation();

    return(
        <Mui.Dialog
            open={props.open} 
            onClose={props.onReopen} 
            fullWidth
            maxWidth="sm" 
        >
            <Mui.DialogTitle>
                <Mui.Grid container spacing={1}>
                    <Mui.Grid item color={customTheme.palette.accent.main}>
                        <InfoIcon color="inherit" />
                    </Mui.Grid>
                    
                    <Mui.Grid item>
                        <Mui.Typography variant="h5">
                            {t("damageForm.details.dialogs.reopenConfirmation.title")}
                        </Mui.Typography>
                    </Mui.Grid>

                    <Mui.Grid item marginLeft={"auto"} >
                        <Mui.IconButton onClick={props.onReopen} style={{padding: "0px"}} >
                            <CloseIcon />
                        </Mui.IconButton>
                    </Mui.Grid>
                </Mui.Grid>
            </Mui.DialogTitle>
            <Mui.DialogContent>
                <Mui.Typography>
                    {t("damageForm.details.dialogs.reopenConfirmation.body1").replace("#textElement", props.taskName)}
                </Mui.Typography>

            </Mui.DialogContent>
            
            <Mui.DialogActions>
                <Mui.Button variant="outlined" size="smallPlus" onClick={props.onReopen}>
                    <Mui.Typography color={'accent'} variant="h6">
                        {t("damageForm.details.dialogs.closeConfirmation.btnCancel")}
                    </Mui.Typography>
                </Mui.Button>

                <Mui.Button type="submit" onClick={props.onReopenTask} size="smallPlus">
                    <Mui.Typography color={'accent'} variant="h6">
                        {t("damageForm.details.dialogs.reopenConfirmation.btnReopenTask")}
                    </Mui.Typography>
                </Mui.Button>
            </Mui.DialogActions>
        </Mui.Dialog>
    )
}
export default ReopenTaskConfirmation;